import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import * as userActions from "actions/user";
import _ from "lodash";
import cx from "classnames";
import ScreenSize from "../ScreenSize";
import Button from "widgets/Button";
import {
	Avatar,
	Dropdown,
	Menu,
	Typography,
	Divider,
	Popover,
	Tooltip,
} from "antd";
const { Text } = Typography;
import { AllAppsNavIcon } from "images/navigationIcons";
import avaLogoIcon from "images/upgrad/ava-logo-icon.svg";
import adminLogoIcon from "images/upgrad/admin-logo-icon.svg";
import apolloLogoIcon from "images/upgrad/apollo-logo-icon.svg";
import testsLogoIcon from "images/upgrad/tests-logo-icon.svg";
import zeusLogoIcon from "images/upgrad/zeus-logo-icon.svg";
import { QuestionCircleFilled, DownOutlined } from "@ant-design/icons";
import styles from "./index.scss";
import routePaths from "../../Router/routePaths";

class ProfileMenu extends Component {
	static propTypes = {
		userInfo: PropTypes.object.isRequired,
		userActions: PropTypes.object.isRequired,
		isMobile: PropTypes.bool,
	};

	constructor(...args) {
		super(...args);
		this.state = {
			showMenuPreview: false,
		};
	}

	handleUserLogout = () => {
		this.props.userActions.logoutUser();
	};

	render() {
		const { isLoggedIn } = this.props.userInfo;
		const userMenu = (
			<Menu style={{ minWidth: "200px" }}>
				<Menu.Item>
					<div className={styles.avatarWrapper}>
						<Avatar
							size="large"
							style={{ margin: "20px 8px 20px 0" }}
							src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png"
							alt="avatar"
						/>
						<span>{_.get(this.props.userInfo, "name")}</span>
						<span>{_.get(this.props.userInfo, "email")}</span>
					</div>
				</Menu.Item>
				<Menu.Divider />
				{/* <Menu.ItemGroup title="SETTINGS">
					<Menu.Item>My Profile</Menu.Item>
				</Menu.ItemGroup> */}
				<Menu.ItemGroup title="HELP">
					<Menu.Item>
						<NavLink to={routePaths.docsPage__overview}>
							Platform Docs
						</NavLink>
					</Menu.Item>
					<Menu.Item>
						<a
							href="mailto:techsupport@upgrad.com"
							target="_blank"
							rel="noopener noreferrer"
						>
							Contact Support
						</a>
					</Menu.Item>
				</Menu.ItemGroup>
				<Menu.Divider />
				<Menu.Item onClick={this.handleUserLogout}>
					<Text type="danger">Logout</Text>
				</Menu.Item>
			</Menu>
		);
		return (
			<div
				className={cx(styles.root, {
					[styles.active]: isLoggedIn,
					[styles.isMobile]: this.props.isMobile,
				})}
			>
				{!this.props.isMobile ? (
					<>
						<div className={styles.allAppIcon}>
							<Popover
								content={
									<div className={styles.popupMenuWrapper}>
										<a
											href="https://apollo.upgrad.com"
											className={styles.popupMenuItem}
										>
											<div className={styles.info}>
												<div className={styles.img}>
													<img src={apolloLogoIcon} />
												</div>
												<div className={styles.detail}>
													<div
														className={styles.title}
													>
														Apollo
													</div>
													<div
														className={styles.desc}
													>
														upGrad Apollo
													</div>
												</div>
											</div>
										</a>
										<a
											href="https://zeus.upgrad.com"
											className={styles.popupMenuItem}
										>
											<div className={styles.info}>
												<div className={styles.img}>
													<img src={zeusLogoIcon} />
												</div>
												<div className={styles.detail}>
													<div
														className={styles.title}
													>
														Zeus
													</div>
													<div
														className={styles.desc}
													>
														upGrad Learn
													</div>
												</div>
											</div>
										</a>
										<a
											href="https://ava.upgrad.com"
											className={styles.popupMenuItem}
										>
											<div className={styles.info}>
												<div className={styles.img}>
													<img src={avaLogoIcon} />
												</div>
												<div className={styles.detail}>
													<div
														className={styles.title}
													>
														Ava
													</div>
													<div
														className={styles.desc}
													>
														upGrad Careers & Outcome
													</div>
												</div>
											</div>
										</a>
										<a
											href="https://tests.upgrad.com"
											className={styles.popupMenuItem}
										>
											<div className={styles.info}>
												<div className={styles.img}>
													<img src={testsLogoIcon} />
												</div>
												<div className={styles.detail}>
													<div
														className={styles.title}
													>
														Tests
													</div>
													<div
														className={styles.desc}
													>
														upGrad - Test as a
														Service
													</div>
												</div>
											</div>
										</a>
										<a
											href="https://admin.upgrad.com"
											className={styles.popupMenuItem}
										>
											<div className={styles.info}>
												<div className={styles.img}>
													<img src={adminLogoIcon} />
												</div>
												<div className={styles.detail}>
													<div
														className={styles.title}
													>
														Admin (Legacy)
													</div>
													<div
														className={styles.desc}
													>
														upGrad - Old Admin Panel
													</div>
												</div>
											</div>
										</a>
									</div>
								}
								trigger="click"
								placement="bottom"
								style={{
									borderRadius: "6px",
									boxShadow:
										"0 10px 40px rgba(0, 0, 0, 0.15)",
								}}
							>
								<img src={AllAppsNavIcon} />
							</Popover>
						</div>

						<NavLink to={routePaths.docsPage__overview}>
							<Tooltip placement="bottom" title="Phoenix Help">
								<QuestionCircleFilled
									style={{
										margin: "20px 0 20px 0",
										paddingTop: "4px",
										fontSize: "20px",
										color: "rgba(255, 255, 255, 0.5)",
									}}
								/>
							</Tooltip>
						</NavLink>
						<div className={styles.profileMenuWrapper}>
							<Dropdown overlay={userMenu}>
								<a
									className={cx(
										styles.menuLink,
										"ant-dropdown-link"
									)}
									onClick={(e) => e.preventDefault()}
								>
									<Avatar
										size="small"
										style={{ margin: "20px 8px 20px 0" }}
										src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png"
										alt="avatar"
									/>
									{_.get(this.props.userInfo, "name")}{" "}
									<DownOutlined />
								</a>
							</Dropdown>
						</div>
					</>
				) : (
					<div className={styles.mobileProfileWrapper} mode="inline">
						<div className={styles.avatarWrapper}>
							<Avatar
								size="large"
								style={{ margin: "20px 8px 20px 0" }}
								src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png"
								alt="avatar"
							/>
							<span>{_.get(this.props.userInfo, "name")}</span>
							<span>{_.get(this.props.userInfo, "email")}</span>
						</div>
						<Divider />
						<Button
							type="danger"
							block
							onClick={this.handleUserLogout}
						>
							Logout
						</Button>
					</div>
				)}
			</div>
		);
	}
	f;
}

function mapStateToProps(state) {
	return {
		userInfo: state.userInfo,
		common: state.common,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		userActions: bindActionCreators(userActions, dispatch),
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ScreenSize(ProfileMenu));
